// @core/api/endpoints/affiliate/list_payouts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPayoutsResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List payouts
 * Returns a paginated list of payouts. Supports filtering and sorting.
 */
export async function ListPayouts(
  params?: PaginatedRequest & {
    affiliate_id?: string | number | boolean;
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListPayoutsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payouts`;
  const requestOptions = options;
  return client.get<ListPayoutsResponse>(requestPath, { ...requestOptions, params });
}
